import React from "react";
import classes from "./noteList.module.scss";
import { TableWide } from "../../../modules/list-pc";
import { TableDataColumns, TableDataMobile } from "./noteRow";
import { TableMobile } from "modules/list-mobile";
import { URLink, VLLink, OtherLink } from "../../../modules/uri";

export default function NoteList(props: { invoices: any[] }) {

    const productCodes = props.invoices.map((i) => i.mainProductCode) || [];
    const checkURProduct = () => {
        return productCodes.map((i) => (i.substr(0, 2))).indexOf('UR')
    }
    const checkVLProduct = () => {
        return productCodes.map((i) => (i.substr(0, 2))).indexOf('VL')
    }
    const checkOtherProduct = () => {
        return productCodes.map((i) => (i.substr(0, 2))).filter((code) => code !== 'VL' && code !== 'UR')
    }
    const getContents = () => {
        const contents = []
        if (checkURProduct() >= 0) {
            contents.push({ title: "Quỹ liên kết đơn vị", link: URLink, code: 'UR' })
        }
        if (checkVLProduct() >= 0) {
            contents.push({ title: "Quỹ liên kết chung", link: VLLink, code: 'VL' })
        }
        if (checkOtherProduct().length > 0) {
            contents.push({ title: "Quỹ chủ hợp đồng", link: OtherLink, code: 'OT' })
        }
        return contents
    }
    return (
        <div className={classes.wrapper}>
            <div className={classes.listSection}>
                <TableWide
                    columns={[]}
                    Rows={TableDataColumns}
                    data={getContents()}
                />
            </div>

            <div className={classes.listSectionMobile}>
                {getContents().map((_, index) => (
                    <div key={index}>
                        <TableMobile Rows={TableDataMobile} data={_} />
                    </div>
                ))}
            </div>
        </div>
    );
}
